/* global translation */
import { closePopup, closestByClassName } from './functions';

if (document.body.classList.contains('woocommerce-cart')) {
  const addOptionalGiftToCard = () => {
    const buttons = document.querySelectorAll('.free-gift-line .add-optional-gift-to-cart');

    buttons.forEach((button) => {
      button.addEventListener('click', (event) => {
        event.preventDefault();

        // eslint-disable-next-line camelcase
        const { productId: product_id, giftId: gift_id, variationId: variation_id } = button.dataset;
        const postData = {
          action: 'add_optional_gift_product',
          product_id,
          variation_id,
          gift_id,
        };

        jQuery.post(translation.ajaxurl, postData, () => {
          const updateButton = document.querySelector('.actions button[name=update_cart]');
          updateButton.removeAttribute('disabled');
          updateButton.click();
          closePopup(button);
        });
      });
    });
  };

  const togglePopUps = () => {
    addOptionalGiftToCard();
    const popupToggles = Array.from(document.getElementsByClassName('toggle-free-gift-popup'));

    popupToggles.forEach((popUpButton) => {
      popUpButton.addEventListener('click', (event) => {
        event.preventDefault();
        const liElement = closestByClassName(popUpButton, 'free-gift-line');
        const popup = liElement.querySelector('.popup');
        popup.classList.add('open');
      });
    });
  };

  setTimeout(() => {
    togglePopUps();
  }, 100);
  jQuery(document.body).on('updated_cart_totals', togglePopUps);
}
